export function wait(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

type WaitFoOptions = {
  wait?: number;
  timeout?: number;
};

export async function waitFor(fn: () => boolean | Promise<boolean>, options: WaitFoOptions = {}) {
  options = {
    wait: 10,
    ...options,
  };
  let result = false;
  let timedOut = false;
  const startTime = new Date().getTime();

  while (!result && !timedOut) {
    const currentTime = new Date().getTime();
    result = await fn();
    if (!result) await wait(options.wait!);
    if (options.timeout) {
      timedOut = currentTime - startTime > options.timeout;
    }
  }
}
